export const CURRENCY_CODE = 'AUD';

export const BRAND_NAME = 'Tilecloud';

export const LANGUAGE_CODE = 'EN';

export const ROUTES = {
  ACCOUNT: '/account',
  ORDER_DETAILS: '/account/orders',
  ADDRESSES: '/account/addresses',
};

export const SEARCH_PARAMS = {
  PAGE: 'page',
} as const;

// Site configuration with production and development URLs
export const SITE_CONFIG = {
  TILECLOUD: {
    name: 'TileCloud',
    href: 'https://tilecloud.com.au',
    devHref: 'http://localhost:3000',
    id: 'tilecloud',
    currencyCode: 'AUD',
    locale: 'en-AU',
  },
  YABBY: {
    name: 'Yabby',
    href: 'https://yabby.com.au',
    devHref: 'http://localhost:3001',
    id: 'yabby',
    currencyCode: 'AUD',
    locale: 'en-AU',
  },
  TRADE: {
    name: 'Trade',
    href: 'https://verandahtrade.com.au',
    devHref: 'http://localhost:3002',
    id: 'trade',
    currencyCode: 'AUD',
    locale: 'en-AU',
  },
  DAWN: {
    name: 'Dawn',
    href: 'https://dawnlighting.com.au',
    devHref: 'http://localhost:3003',
    id: 'dawn',
    currencyCode: 'AUD',
    locale: 'en-AU',
  },
} as const;

export type SiteId = (typeof SITE_CONFIG)[keyof typeof SITE_CONFIG]['id'];

export const QUERY_KEYS = {
  PRODUCT_LISTING_PRODUCTS: 'productListingProducts',
  PRODUCT_LISTING_PAGE_COUNT: 'productListingPageCount',
  WISHLIST_PRODUCTS: 'wishlistProducts',
} as const;

export const DATA_NAMES = {
  NAVBAR: 'navbar',
  ANNOUNCEMENT_BANNER: 'announcement-banner',
  STORE_SELECTOR: 'store-selector',
} as const;

// ! Keep this in sync with the version of the docs pulled in in tsconfig.json for the typegen
export const SHOPIFY_VERSIONS = {
  STOREFRONT: '2025-04',
  ADMIN: '2025-04',
  CUSTOMER_ACCOUNT: '2025-04',
} as const;

export const BLOG_TYPES = {
  NEWS: 'news',
  CUSTOMER_EDUCATION: 'customer-education',
  POST_DESIGN_APPOINTMENT_STEPS: 'post-design-appt-blog-steps',
  STYLE_QUIZ_STYLES: 'style-quiz-styles',
  TILECLOUD_STYLE_BOHEMIAN: 'tilecloud-style-bohemian',
} as const;

export type BlogType = (typeof BLOG_TYPES)[keyof typeof BLOG_TYPES];
